import React, { useEffect, useState } from 'react'
import { Button, Alerts, DatePicker, TimePicker, Toast } from '@kaleyra/emmy'
import { useTranslation } from 'react-i18next'
import { C2CCallInterface } from '../../../store/models/C2CModal.interface'

import Styles from '../index.module.scss'
import { cloneDeep, range } from 'lodash'
import moment from 'moment'

export type Props = {
    closeModal: () => void;
    translateMessages: (msg: string) => string;
    callData: any
}

export type MapStateToPropsType = {
    C2CCall: C2CCallInterface,
}

export type MapDispatchToPropsType = {
    clickToCall: (data: any,
        cbS: (a: string) => void,
        cbE: (a: string) => void) => void,
    closeC2CModal: () => void,
}

const ScheduleCall: React.FC<Props & MapStateToPropsType & MapDispatchToPropsType> = ({
    C2CCall,
    closeModal,
    translateMessages,
    callData,
    clickToCall,
    closeC2CModal,
}) => {

    const [date, setDate] = useState<any>(null)
    const [time, setTime] = useState<any>(null)
    const [pickedHour, setPickedHour] = useState<any>(null)

    const { callInitiated } = C2CCall
    const { t } = useTranslation()
    const { agentNumber, customerNumber, callerId, retryNumber, dialPreference, callbackProfile, modalSource, call_id } = callData

    useEffect(() => {
        setDate(moment().add(30, 'm'))
        setTime(moment().add(30, 'm'))
        setPickedHour(moment().add(30, 'm'))
    }, [])

    useEffect(() => {

        // reset the time (if not valid) when date is switched from future date to today's date

        if (date) {
            const selectedDate = cloneDeep(date)
            if (moment().day() === selectedDate.day()) {

                if (time && time.hour() < selectedDate.hour()) {
                    setTime(moment().add(30, 'm'))
                    return
                }

                if (time && time.minute() < selectedDate.minute()) {
                    setTime(moment().add(30, 'm'))
                    return
                }
            }
        }
    }, [date])

    const handleClickToSave = () => {
        let saveTime = ''
        if (date && time) {
            saveTime = `${date.format().split('T')[0]}T${time.format().split('T')[1]}`
        }
        const data = {
            to: customerNumber,
            from: agentNumber,
            bridge: callerId,
            retry: retryNumber,
            dial_first: dialPreference,
            source: modalSource,
            time: saveTime,
            call_id,
            ...(callbackProfile ? { 
                // dlrurl: JSON.stringify([{ "callback_profile": [callbackProfile] }]) 
                callback: JSON.stringify({call_end:{callback_profile:[callbackProfile]}})
            } : {})
        }
        clickToCall(data,
            (msg: string) => {
                Toast(translateMessages(msg) || msg, 'success')
                closeModal()
                closeC2CModal()
            },
            (errorMsg: string) => {
                Toast(translateMessages(errorMsg) || errorMsg, 'error')
            }
        )
    }

    const disabledDate = (dateVal: any) => {

        // disable date more than 3 days from today

        return (
            dateVal &&
            (
                dateVal < moment().subtract(1, 'days').endOf('day').add(15, 'm') ||
                dateVal > moment().add(4, 'days').startOf('day')
            )
        );
    }

    const disableMinutes = (hour: number) => {

        // disable 15 minutes from current time

        const selectedDate = cloneDeep(date)
        const selectedHour = cloneDeep(pickedHour).hour()
        if (moment().add(15, 'm').day() !== moment().day()) {
            const min = moment().add(15, 'm').minute()
            return range(0, min)
        }

        if (moment().day() === selectedDate.day()) {
            if (moment().add(15, 'm').hour() === selectedHour) {

                const min = moment().minute()
                if (min + 15 >= 60) {
                    return range(0, ((min + 15) - 59))
                }
                return range(0, min + 15)
            } else {
                return []
            }

        }
        return []
    }

    const disableHours = () => {

        // disable the current hour (if 15 minutes in future changes the hour)

        const selectedDate = cloneDeep(date)

        if (moment().add(15, 'm').day() !== moment().day()) {
            return []
        }

        if (moment().day() === selectedDate.day()) {
            const hour = moment().hour()
            const min = moment().minute()
            if (min + 15 >= 60) {
                return range(0, hour + 1)
            }
            return range(0, hour)
        }
        return []
    }

    return (
        <div className={Styles.scheduleCall}>
            <Alerts type='warning'
                content={t('scheduleCallMsg')}
            />

            <div className={Styles.dateTimePicker}>
                <DatePicker
                    className={Styles.dateTimeWrapper}
                    disabledDate={disabledDate}
                    onChange={(dateVal, dateString) => {
                        setDate(dateVal)
                    }}
                    value={date}
                    allowClear={false}
                />
            </div>

            <div className={Styles.dateTimePicker}>
                <TimePicker
                    className={Styles.dateTimeWrapper}
                    onChange={(val, dateString) => setTime(val)}
                    disabledMinutes={disableMinutes}
                    disabledHours={disableHours}
                    showNow={false}
                    value={time}
                    onSelect={val => setPickedHour(val)}
                    format={'HH:mm'}
                />
            </div>

            <div className={Styles.footer}>
                <span className={Styles.cancelBtn} onClick={() => closeModal()}><Button type='tertiary'>{t('mainCancel')}</Button></span>
                <span>
                    <Button
                        disabled={!date || !time || callInitiated}
                        onClick={() => handleClickToSave()} type='primary'>
                        {t('mainSave')}</Button>
                </span>
            </div>
        </div>
    )
}

export default ScheduleCall